export default {
  app: {
    languagePopup: {
      title: 'Actualmente estás en la versión en inglés de {logo}',
      subtitle: '¿Deseas cambiar a tu idioma preferido?',
      cta: 'Cambiar a {lang}',
    },
  },
};
